import { PageListCachedDataSource } from './BaseDataSources';
import { IServicer } from '../Interfaces';

export class ServicerSource extends PageListCachedDataSource<IServicer> {
 /**
 * @param {boolean} isActive - An optional parameter for filtering active records.
 */
  public constructor(isActive?: boolean, private _includeUnknown = false) {
    super('/datasource/servicers', { isActive });
  }

  protected getStaticData(): IServicer[] {
    if (this._includeUnknown)
      return [{ internalId: -1, id: '-1', name: 'Unknown' }];
    return [];
  }
}